import React from "react";

export default function LinkedIn() {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 1.69828C0.5 0.9075 1.16203 0.265625 1.97812 0.265625H19.0219C19.8383 0.265625 20.5 0.9075 20.5 1.69828V18.8332C20.5 19.6242 19.8383 20.2656 19.0219 20.2656H1.97812C1.16211 20.2656 0.5 19.6243 0.5 18.8334V1.69805V1.69828Z"
          fill="#0A66C2"
        />
        <path
          d="M6.57785 17.0047V8.00062H3.58504V17.0047H6.57816H6.57785ZM5.08207 6.77148C6.12551 6.77148 6.77511 6.08008 6.77511 5.21602C6.75558 4.33227 6.12551 3.66016 5.10191 3.66016C4.07761 3.66016 3.40863 4.33227 3.40863 5.21594C3.40863 6.08 4.05801 6.77141 5.06246 6.77141H5.08183L5.08207 6.77148ZM8.23441 17.0047H11.227V11.977C11.227 11.7082 11.2465 11.4388 11.3256 11.2468C11.5418 10.7089 12.0343 10.1521 12.8612 10.1521C13.9439 10.1521 14.3772 10.9777 14.3772 12.1883V17.0047H17.3697V11.842C17.3697 9.07648 15.8935 7.78953 13.9245 7.78953C12.3102 7.78953 11.6012 8.6918 11.2073 9.30633H11.2272V8.00094H8.23457C8.27363 8.84562 8.23433 17.005 8.23433 17.005L8.23441 17.0047Z"
          fill="white"
        />
      </svg>
    </>
  );
}
